import { Component, OnInit } from "@angular/core";
import { RestService } from "../rest.service";

@Component({
  selector: "app-auth-user-list",
  templateUrl: "./auth-user-list.component.html",
  styleUrls: ["./auth-user-list.component.css"],
})
export class AuthUserListComponent implements OnInit {
  oktaUser: any;
  keyword = "name";
  data: any = [];

  constructor(private _restService: RestService) {}

  ngOnInit() {
    this._restService
      .getOktaUser()
      .subscribe(
        (oktaUsers) => (
          (this.oktaUser = oktaUsers), (this.data = this.oktaUser.oktausers)
        )
      );
  }

  selectEvent(item: any) {
    console.log("Selected items ----->>", item);
    this._restService.updateRegisteredUserDetails(item);
  }
}
